import { render } from "./AdicionarSelecao.vue?vue&type=template&id=5e497d19&ts=true"
import script from "./AdicionarSelecao.vue?vue&type=script&lang=ts"
export * from "./AdicionarSelecao.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__